const $showTermsOfServiceLink = document.querySelector(".show-terms-of-service-link");

const handleShowTermsOfService = (event) => {
  event.preventDefault();
  document.querySelector(".modal.terms-of-service-modal").classList.add("is-active");
};

if ($showTermsOfServiceLink) {
  $showTermsOfServiceLink.addEventListener("click", handleShowTermsOfService);
}

const $showPrivacyPolicyLink = document.querySelector(".privacy-policy-link");

const handleShowPrivacyPolicy = (event) => {
  const { target } = event;

  const href = target.getAttribute("href");

  if (href === "" || href === "#") {
    event.preventDefault();

    document.querySelector(".modal.privacy-policy-modal").classList.add("is-active");
  }
};

if ($showPrivacyPolicyLink) {
  $showPrivacyPolicyLink.addEventListener("click", handleShowPrivacyPolicy);
}
